import { useEffect, useMemo, useRef } from 'react'

import styles from './TextRender.module.scss'

export default function TextRender({ text }) {
  const lastRef = useRef()

  const paragraph = useMemo(() => {
    return (text || '').split('\n')
  }, [text])

  useEffect(() => {
    if (lastRef.current) {
      lastRef.current.scrollIntoView()
    }
  }, [paragraph])

  return (
    <div className={styles.container}>
      {
        paragraph.map((p, index) => <p key={index}>{p}</p>)
      }
      <span ref={lastRef}/>
    </div>
  )
}
